// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__26aiy","box":"WorkspacesBox_box__2c1-Y","node":"WorkspacesBox_node__2AzXt"};